const doc = [({"en":({"js":({"merfoto":({"layout":({"top_bar":({"index":({"sign_in":"Sign in"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;